// extracted by mini-css-extract-plugin
module.exports = {"container":"Geolocation_container__DTwwB","geolocationButton":"Geolocation_geolocationButton__33LwP"};